module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "bullet",
      "src": "images/bullet.jpg"
    }
  }), _vm._v(" 3 "), _c('img', {
    attrs: {
      "alt": "bullet",
      "src": "images/bullet.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "paraa"
  }, [_c('em', [_vm._v("Wild Man Wade of ATO")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('em', [_vm._v("“Bad Moon Rising”")]), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDENCE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEARWATER")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVIVAL")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_c('em', [_vm._v("The past. Friday, October 3,1969. 6:55 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M")]), _vm._v(". College Circle, Atlanta")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/dot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Style26"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("“JANE!”")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("I")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLERED")]), _vm._v(" through the locked bathroom door over the sound of “Sugar, Sugar” on my big sister’s transistor. “Hurry up. I’m gonna wet myself!” A major peril of living in a two-bathroom house with seven other people. “You shouldn’t even be up here!” Jane’s bedroom was downstairs. “Go downstairs, where you belong.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Can’t. Taken,” she said with her usual aplomb, her calm voice and the music echoing off the white and black tiles. “Just a few more eyelashes, and I’m done.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Eyelashes! Major violation of the Peyton house bathroom code. Cosmetics did not grant exclusivity from your sisters in the facilities.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I grabbed a letter opener from my desk and popped open the lock, then hurried past my oldest sister, who was wearing white lace bikinis and a French bra as she leaned toward the medicine cabinet mirror with acute concentration.")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“You cannot lock the door for eyelashes,” I scolded, barely getting ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("my underpants, pantyhose, and girdle down in time to relieve my distended bladder. “It’s seven o’clock. The last thing I want my date to do is look up the stairs through the front door and see me coming out of the bathroom. How embarrassing.”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("Jane remained unruffled, as always. “Relax. Guys are never punctual.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“John will be. He’s a scientist. Scientists are very precise. And reliable. And we’re doubling, so if he’s late, we’ll be late picking up Linda.” I hoped John’s best friend was as nice as he was.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I couldn’t wait for Linda to meet John. I’d told her all about him, but I’d held out about the warm little glow I’d felt when he’d asked me out for coffee after the night class he was teaching at State. I’d been admiring him for a week while he explained basic physics in his laid-back, logical way, never dreaming he might be attracted to me. I mean, he was a professor, for heaven’s sake. But then again, he barely looked five years older than the students he taught.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Who knew he was some kind of genius who’d graduated from MIT at nineteen and become the youngest full professor in the history of Georgia Tech? All I knew was, he was really cute and sort of sexy in a wonderfully lanky, self-conscious way.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("The attraction was nothing so earth-shaking as what I’d felt for my bad-boy high school lover Brad, but John was the first guy who’d even put a hum into my chimes since. Better yet, he was completely stable and logical. I just knew Linda would like him, which was important, because my gang of best friends could be merciless about boyfriends—for our own protection, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I wondered what it would feel like to kiss him.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I flushed the potty, then stood to carefully arrange my Eve’s Leaves bikini pants and smooth the shirttail to my blouse underneath my suntan pantyhose so there’d be no visible lines. Then I pulled up my mandatory gut-sucker girdle from Lerner’s that minimized my boxy hips and slight tummy pooch.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("It was only years later that I realized Mama’s mandatory girdle rule was her polite, repressed effort to discourage her daughters from impetuous sex. Not that it worked for me with Brad, but the rest of my sisters were less prone to throw caution to the wind than I.")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("I washed my hands as Jane inspected the last clump of lashes with a satisfied sigh. “There. What do you think?” She blinked at me.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("Her hazel eyes looked as huge as Twiggy’s, which was great, because they offset the fact that her chin wasn’t quite as strong as it should be. I nodded. “Wonderful. But next time, do it in your bedroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“How can a person get any time alone in this house?” She slung on her short kimono robe, then reached for the doorknob.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Wait!” I warned her. “What if John’s down there now?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("If he saw my big sister coming out of the bathroom in her scant kimono, our relationship would be doomed before it started.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Jane patted my shoulder. “Do you actually think he’s standing at the door, not ringing the bell, and peering up the stairs for a glimpse of the bathroom? He doesn’t even know this is a bathroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“He will if he sees you,” I shot back.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("The doorbell rang, sending a mild shock of adrenaline through me. “See!” I hissed. “Now we’ll have to wait here till he’s in the living room.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I cracked the door and listened to hear who would let John in. Please, not one of my brothers. No matter how many times Daddy lectured them, they were invariably crude to our dates, especially first-timers. Then I heard the familiar creak of my father’s steps on the wooden floor of the front hall. The door opened, and Daddy said, “Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Hi. I’m John Baker,” John said in a firm, man-to-man tone that carried easily up the stairwell. “I’m here for Georgia. May I come in?” A+ on the greeting! Yes!")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Come right on in, young man,” Daddy’s baritone said with obvious approval. “I’m Georgia’s father. Tech, class of ‘48. Take a seat. I’ll tell her you’re here.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("It stung, knowing John was seeing our shabby, worn-out furniture and stained, late-forties knotty pine paneling. But that was how we lived. No sense trying to hide it.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I cracked the door wider and saw Daddy stick his head into the stairwell. “Georgia, your young man is here,” he said genially, then his smile turned to a glare of disapproval when Jane hurried into my room with her robe slung immodestly low.")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“Tell him I’ll be right down,” I said, then waited, poised to eavesdrop. Daddy always liked some time alone to interview our new dates.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("Jane stretched out on my bed and pretended to read my copy of "), _c('em', [_vm._v("Seventeen")]), _vm._v(", but she was listening, too.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I whispered to her, “Put that back when you’re finished with it.” She smirked at me.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“So,” Daddy said when he plopped down with a squeak of protest from his red vinyl chair. “How did you and Georgia meet?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John’s answer was respectful, but direct. “She’s one of my students in a basic physics night class I’m teaching at State.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“I thought she said you taught at Tech,” Daddy said with deceptive mildness. I’d neglected to mention that John was my teacher, for fear Daddy might object. But it was out now.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“I do teach at Tech,” John said, anything but defensive. “But I pick up a little extra income teaching night school at State when they need somebody. I’ve been so focused on work till now, I’ve never had much of a social life.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Nothing wrong with that,” Daddy said. “First things first, I always say.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I heard Mama come in from the kitchen, and the sofa groan as John rose.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Hi,” Mama said. “You must be John. I’m Georgia’s mother. May I get you something to drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("It was a test. If he asked for anything alcoholic, he’d lose major points.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“No thank you, ma’am. I’m just fine. But thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Daddy’s voice hardened. “So, they let you date your students at")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("State?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Walter!” Mama scolded gently. “Where are your manners?”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("To his credit, John wasn’t intimidated. “It’s okay, ma’am. I’d rather hear what Mr. Peyton really thinks, straight out.” He addressed my father. “Dating students is not forbidden, but it’s not encouraged, either.” Regardless of the Age of Aquarius and free love, this was Atlanta, after all, where we maintained the illusion, at least, of decorum. “Of course, we don’t have many women at Tech yet,” John clarified, ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("“so the administration is still formulating policies for a co-ed environment.”")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("Daddy let out a skeptical, “Mmmmmm.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John cut to the chase. “I assure you, sir, I will treat your daughter with the utmost respect and restraint. And I also assure you, Georgia won’t get any special grade concessions from me just because we’re seeing each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Caught off-guard, Daddy barked a laugh and relaxed. “Well, that’s a shame, ‘cause she’s gonna need all the help she can get. Georgia never has been much of a science or numbers person. Makes hundreds in all her liberal arts courses, but those others . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I cringed. "), _c('em', [_vm._v("Please don’t start with the anecdotes about my mathematical deficiencies!")])]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("But John took it in good humor. “She’s clearly intelligent. Maybe I could help her out with a few key concepts. I’m sure she’ll do fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Before I could digest that, Daddy said in his hunker-down voice, “Listen, have I got a story for you . . .” Oh, no! “Last year when she took her checkbook and statements up to the bank to try to get them to help her straighten it out—”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Embarrassing stories were an inescapable part of a big family, but I didn’t like being laughed at.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I raced downstairs, hoping the clatter would drown Daddy out, but I didn’t make it to the living room till he was finishing with the punch line.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“So the bank guy told her to let the account die, then gave her two boxes of Sophie Mae Peanut Brittle if she’d promise to take her business to their competition.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John had just started to chuckle when I walked in with a frosty look on my face. He stood abruptly, a brief flash of embarrassment replaced by a look of raw appreciation. “Wow. You look . . . great. Really great.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I swear, he said it on the inhale, erasing my annoyance at Daddy.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“You look pretty good yourself.” Oh lord, did I say that out loud?")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("But it was true. Nobody had ever picked me up for a regular date in a sport coat and tie. John’s navy blazer and trim gray slacks showed off his tall, runner’s physique, and his white button-down ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("shirt with a subdued tie were classic and elegant without being pretentious. He even had on grown-up oxblood tasseled slip-ons . . . expensive ones . . . and socks. (College boys weren’t wearing socks those days.) He looked very much the man, not the college kid.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("Why hadn’t I remembered him as this good-l ooking? Maybe it was the blazer. I’ve always been a sucker for a good-looking guy in a navy blazer.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Daddy took it all in, arching a wary eyebrow. When John stepped forward and offered his arm, Daddy clamped a hand on his shoulder. “This is one of my most precious, young man, even if she can’t balance a checkbook, so I’m counting on you to make good on being a gentleman.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John’s expression sobered as he met father’s gaze. “Georgia’s too fine a lady for me to do anything else, sir.” A+++ on the rebound!")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Daddy clapped John on the back with a little more vigor than was necessary. “I like you, Jim.” John coughed. “It’s John, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Ignore him,” I told John. “Daddy does that to all our first dates.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Daddy just grinned and pushed open our patched screen door ahead of us. “Don’t be a stranger.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Thanks.” John led me outside as if it were the most natural thing on earth to be subjected to an inquisition on a sofa with flesh-seeking coils. “I like your dad,” he said as we walked up the driveway toward his slightly dented Plymouth. “Things wouldn’t be so crazy in this world if there were more fathers like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("He sounded sincere.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I took a chance and asked, “What’s your father like?” An irresistible smile lit his face. “A lot like yours.” “Do you have any brothers or sisters?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Nope.” He cocked his head. “Engine and caboose, that’s me: the only child of two only-child parents and four only-child grandparents. Haven’t got a cousin to my name.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“I don’t either, but I’ve got three sisters and two brothers.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("He pulled a little face. “Wow.”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("John led me to the car’s passenger door, but until I got there, I was ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("too preoccupied with him to notice that there was a guy sprawled, slack-jawed, in the back seat, broadcasting whiskey fumes with every breath. When I turned to get in and saw him, I turned right back around and grabbed John’s lapels. “Tell me this is not the best friend you had me get a date with Linda for.”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("For the first time, he withdrew into a closed expression. “I know it looks bad, but he swore he wouldn’t drink. I didn’t know he’d had a few till I picked him up.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Had a few?” I growled out through a rigid grin worthy of the Joker, lest anybody see my outrage. “He’s smashed. You bring a drunken sot to go out with my best friend? What happened to all that talk about respect?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John colored. “He got in the car and refused to get out, and I didn’t want to be late picking you up.” John was so earnest, I decided to give him the benefit of the doubt. And I really, really wanted to go out with him.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“What’s his name?” I asked, still smiling for public consumption.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Wade Bowman.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Any chance we could sober him up?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Definite chance. I swear, sometimes he just needs to hang his head out of the window for a few miles, then he’s charming as hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Not an image I wanted to be any part of, but I didn’t have a better idea.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I leaned into the open back window. Maybe he wasn’t passed out. Maybe he was just napping. Dodging distillery breath, I hollered, “Wade!”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("He popped bolt upright, took one look at me, gasped as if he were seeing the throne of God, and rasped out, “Nancy! You’re alive!”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("The next thing I knew, he’d dragged me halfway through the window and planted a huge, horribly wet and tonguey French kiss on me, muttering “Nancy” over and over again beneath it. Legs flailing, I was mortified to know my girdle was on display for the whole neighborhood as I tried to escape.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John did the only thing he could: He grabbed my waist and tried to pull me back out. “Wade! It’s not Nancy! Let her go!”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('em', [_vm._v("Oh, lord, please don’t let anybody be looking")]), _vm._v(". But even as I prayed, I ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("knew half the neighborhood had been summoned to their front windows by an extensive network of kid-spies who never missed a thing on our street.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("The first chance I got, I filled my lungs with air, then pinched my assailant’s nose shut and blew as hard as I could into his mouth, puffing out his cheeks like a toad and shocking him enough to let me go. Which sent me tumbling backwards atop John onto the pavement.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Agh! Yacch!” I rubbed the backs of my hands across my plundered tongue as my date helped me up. “Gross! Gross! Gross!”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“God, Georgia, I am "), _c('em', [_vm._v("so")]), _vm._v(" sorry!” John glared bloody murder at Wade when we gained our feet. “He had this girlfriend, Nancy, before they sent him to Vietnam, and when he got back, he was so messed up that she—”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("He didn’t get to finish. Wade exploded out of the car, loaded for bear. “You son-of-a-bitch!” He took a wild swing at John and missed, almost hitting me. “You didn’t even warn me! She looks just like her, and you didn’t have the common decency to warn me.” Even in a drunken rage, his accent was old-money Atlanta.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John shoved me out of harm’s way. “Go back inside where it’s safe. I’ll come talk to you after I’ve gotten him settled down.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("When I saw the curious faces peering at us from my neighbors’ windows, I reacted on instinct and grabbed Wade by the front of his designer golf shirt. “Stop it!” I ordered, the way I did when breaking up my two lunk-headed brothers’ fights. I clamped on to John’s arm. “Get into the car, both of you. Now!”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I shoved Wade into the open rear-passenger door, then slammed it shut, heedless of appendages. Jerking open my door, I turned to John, livid. “I will not be further humiliated by a common street brawl in front of my house,” I said through my fake smile. “Get us out of here before my daddy gets wind of this.” I glared at John, “Or you, mister, will be history with this woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Nodding, he closed my door and hurried around to the driver’s seat. To his credit, he didn’t attract further notice with a screeching takeoff, but made smartly for Northside Drive.")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("After a few moments of sullen silence, both of them started yelling at each other at once. I opened my door and threatened, “Do I have to ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("jump out? Is that what it’s going to take for you two to stop acting like idiots?”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("They lapsed into tense silence. John’s neck and face was mottled with red, while Wade’s had gone the even hue of a tomato.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Now that I can be heard,” I clipped out to John, “we have to talk about this double date. No way am I letting that guy within a mile of")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Linda.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“I swear,” Wade protested, “I’ll make this up to you. I’ll be a perfect gentleman.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Perfect gentlemen do not arrive drunk to pick up their dates,” I snapped. “Or manhandle innocent strangers!”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“John should have warned me that you look so much like Nancy,” Wade accused.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“She doesn’t look like Nancy,” John protested, glaring at Wade in the rearview mirror. “Nancy was brunette.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("So was I, but I’d been putting peroxide into my shampoo since I was eleven. Blondes really do have more fun.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“It’s her eyes,” Wade said intensely, pinning me with a look that could have pierced my skull. “She has her eyes. And her chin. And her cheekbones. And her voice.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“No she does not,” John countered. “You just think so because you’re drunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Please do not talk about me as if I am not present,” I clipped out as we neared the intersection of Northside Parkway and Paces Ferry. “Pull over to the pay phone in that gas station. I’ve got to call Linda.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Do you see what you’ve done?” John said to Wade in the rearview mirror. “You knew how important this was to me, and you ruined it.” We halted with a lurch.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I stomped to the phone, then put in a dime and dialed Linda’s number.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Her mother answered. “Helloooo.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Mrs. Bondurandt, this is Georgia. May I please speak to Linda?”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("“I’ll get her,” Mrs. Bondurandt said, then cupped her hand around the receiver and dropped her voice. “I so appreciate your getting her this date. All she does is sit around home and mope when she’s not with the rest of you girls, but now she’s in there singing like a lark, so ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("happy to be going out with a nice Jewish boy. I can’t thank you enough, sweetie.” Gulp.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("“I hope you got her a smart one,” Mrs. Bondurandt added before putting down the phone with a bonk. “Linda-lapinda,” she called down the hallway, “it’s Georgia.” Even we had two phones, but the Bondurandts only had one in the hallway, which precluded private conversations, but eliminated the possibility for parental eavesdropping on an extension.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I heard brisk steps, then Linda said, “Hi. Please tell me nothing’s gone wrong. I’ve had my hair and nails done, and I bought a new dress.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Much as I wanted to spare her, my best friends and I had long held a common pact that we would never lie to each other, even when it hurt. It was one of our sacred rules of friendship. “Honey, much as I hate to tell you this, there is definitely a problem. My date’s fine, but yours was passed out in the back seat when we got to the car, and when I leaned into the back window to wake him up, he jerked me inside and put such a mash on me, calling me ‘Nancy,’ that I barely escaped with my life. He’s so drunk, he thought I was an old girlfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("After an assessing pause, Linda asked, “Is he good-looking?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“What?” I peered at the grimy receiver, then returned it to my ear. “I tell you this, and all you can say is, is he good-looking?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Well, is he?” She was serious!")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I glanced back to the car, where both of the guys scrutinized my every motion between barbs at each other. “Extremely, in a dissolute kind of way.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Is he nicely dressed?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("For the first time, I paid attention. “Black polo shirt, cotton tennis sweater over his shoulders, and dark gold slacks. Expensive.” I tucked my chin. “What difference does that make? He’s drunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I heard humor in Linda’s voice as she cupped the receiver so her mother couldn’t overhear. “He couldn’t be any worse than my uncle Manny at every family wedding I’ve been to since I turned sixteen. I know how to handle a drunk. This one’s eligible and gorgeous. Bring him on.”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("“Linda, have you lost your mind?”")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Nope,” she said firmly. “But if he’s too smashed to get by Mama, have John pretend he’s my date. And remember to tell him that he’s supposed to be Jewish.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("At least he wouldn’t have to face her father. Except for High Holy Days, Linda’s daddy was hardly ever home. We all accepted without question Mrs. Bondurandt’s explanation that he was traveling on business.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I had a bad feeling about this Wade and Linda thing. “I don’t think this is a good idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Was Brad a good idea?” Linda shot back, going for the jugular. “In case you’ve forgotten, we all warned you about him, but we let you make your own choices.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Touche.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Don’t you want to go out with John?” she challenged.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("The question was rhetorical. I’d already told her how much I was looking forward to this. “You know I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Well, I want to go out, too. And that’s that. MYOB.” Another one of our friendship codes: When one of us tells another to mind her own business, we are obliged to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Well, okay,” I said against my better judgment, “but we are "), _c('em', [_vm._v("not")]), _vm._v(" leaving you alone with him, not for one second.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Agreed,” she said. “Where are y’all?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“At the Gulf Station at Paces Ferry.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Good. See y’all in a minute. I’ll be waiting at the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I hung up and got back into the car. Once there, I turned to point the Finger of Judgment at Wade. “Do you solemnly swear to act like a gentleman, not have anything more to drink, and to treat my friend Linda like the lady she is?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Already looking a lot more sober, Wade flashed me a 9,000-volt grin and raised the Boy Scout salute. “I do so solemnly swear,” he said without a single slur.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I rolled my eyes at John. “Okay, then. Linda wants to go. Why, I cannot fathom, but she wants to go.”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Wade grinned in triumph. I turned back around. “And if anybody asks, you’re Jewish. Conservative. You made your bar mitzvah at ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("twelve, and you go to Ahavath Achim,” I said just to be safe, since the Bondurandts went to the Temple.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("Wade tucked his chin in mock surprise and accused John, “You already told her I was Jewish?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John looked at me. “He’s not Jewish. He’s Episcopalian.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Trust me, the services aren’t that different,” I said, “but the Jewish ones are in Hebrew.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John glared at Wade in the rearview window. “Mess this up any worse, man, and I’ll have to see you behind the Zesto afterwards.” That was where the local hoods went to fight.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I couldn’t see John’s taking his professor self out behind the Dumpsters to get physical with his best friend, but who knew? We’d only known each other for a few weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Fortunately, with the help of half a pack of peppermint Chiclets, a comb through his thick, sun-streaked hair, and a few strategic tucks of his clothing, Wade managed to look quite presentable when he went to the door to collect Linda. Both Mrs. Bondurandt and Linda immediately fell for his considerable charm. As he walked Linda back to the car, her eyes sparkled with happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("True to his word, Wade was attentive and charming all the way back down to Tech for the party. He and Linda made the usual blind-date small talk in low tones in the back seat, while John and I sat in awkward silence up front.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("As we pulled into a crowded parking area behind a Craftsman bungalow just off Tenth Street, John turned back to his friend. “Ginger ale, bucko. Got it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Wade nodded without breaking the rhythm of the story he was telling Linda about Vietnam. Hand clasped over her heart in sympathy, she was eating it up.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("What is it about the bad boys? Why are they so irresistible?")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("But not to me. Not anymore. After losing bad-boy Brad, I hardly had a heart left to care with.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“What are faculty parties like?” I asked John as he helped me out of the car.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Like any other parties. Some are nice. Some are duds. We’re dealing with a lot of brilliant, sometimes socially inept people here.”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("“This will be a good one,” I predicted. “I’ll have you to talk to.”")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("We walked inside to a hodgepodge of Einstein and psychedelic posters, beaded doorways, and mismatched furniture full of people who looked like college kids, just a little older and heavier. And every single one of them checked me out when I came in beside John. Maintaining my cool, I picked up snatches of Bigbrain shop talk where the guys were clustered, while their dates or wives visited with each other about more mundane topics.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John led me to the ancient kitchen, where the linoleum counter served as a bar beside a sink full of iced-down beer. “What can I get you?”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“A tall tonic and lime on the rocks.” No booze for me. Not on a first date. I talked too much when I was nervous to start with. Add a little alcohol, and my tongue got loose at both ends. I didn’t want to blow this. Despite his drunken letch of a friend, I could already tell that John was a keeper.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Tall tonic and lime it is,” he said rooting around till he found the makings, then nabbing a beer for himself.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“I’d have thought you were a Scotch man,” I said as he handed me my drink. “Being a professor and all.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("He made a face and shook his head. “That stuff tastes like Mer-curochrome.” He tipped his beer bottle in my direction. “No, I just usually nurse a beer. Gotta watch what you say at these things. A lot of our research is classified, so it wouldn’t do to get loose-lipped.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Sensible, with the Cold War raging.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Then let’s talk about nonclassified stuff,” I said. “Tell me about growing up.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Okay,” he said, “as long as you do, too.”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("So we talked of our childhoods. His had been white-collar, solid middle class, in contrast to mine, which had been middle class only in concept as my parents struggled to provide for the six of us kids. Maybe it was the fact that John seemed truly interested in my life that made me feel comfortable to confide the frustrations of living in a tiny house with five siblings, where you always had to move something to sit down, and every penny was stretched till it screamed. “At the neighborhood Christmas party one year,” I confided, “Daddy’s ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("gift was a coat of arms with the Latin motto: "), _c('em', [_vm._v("Abundance made me poor.”")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("“I think you’re lucky to have such a big family,” John said. “No, seriously. When you’re an only child, there’s nobody else to take the blame.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("We shared a laugh that built a bridge between our differences.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("After about an hour, I glanced over and saw Linda and Wade dancing, slow and seductive, to “Hurt So Bad” by the Lettermen. It worried me. “I think Linda has definitely taken to Wade. Please tell me he’s not going to drop her after tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John’s expression clouded. “Wade’s . . .complicated.” He shot an empathetic look at his friend. “He and Nancy partied a lot, but nothing drastic. They were seriously in love. Then Wade flunked out and got sent to Vietnam. It did terrible things to him. I hardly knew him when he came back. Nancy was desperate to help him, but he just couldn’t connect. Then she caught him with a hooker, and that was it. She didn’t just dump him; she moved away and didn’t give any of us a forwarding address.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Note to self: Warn Linda about the hookers.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John peered into the neck of his beer bottle as he spoke. “Ironically, that was what it took for him to hit bottom. He tapered his drinking down till he was just having a beer a day for a long time. Then, gradually, it started creeping back up to two beers, then three. But this is the first time in more than a year that he’s gotten drunk.” He cocked an apologetic half-smile my way. “Of all times. I could mop the floor with him, but it wouldn’t do any good.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("He looked to his friend. “I keep hoping he’ll meet someone nice. Someone who can give him a reason to stay sober.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Linda was certainly nice—maybe too nice. I didn’t want Wade to take advantage of her.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Did he ever finish college?” I asked. At our house, that was right up there with the Ten Commandments.")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("John shook his head. “No. He couldn’t focus anymore.” He sighed. “I only told you all this so you could know what your friend might be getting into. But Wade’s got a good heart. I can’t tell you ")]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("the things he’s done for me.” His expression lightened. “Including bugging me till I finally mustered up the courage to ask you out. I really owe him.”")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("I looked at the thoughtful, compelling man beside me. “Then I owe him, too.” I turned to watch Linda swaying, her petite cheerleader’s body shaped to Wade’s tall one. “I just hope he doesn’t hurt her.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John put his arm around me, a warm, reassuring gesture. “Wade and Linda will have to work that out for themselves. But I can promise you one thing,” he said gazing into my eyes. “I would never do anything to hurt you. Ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I relaxed against his shoulder, my head fitting perfectly below his chin. “I believe you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("It wasn’t the love of a lifetime, but it was good and sure and safe. Just as good and sure as Wade was dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I hoped Linda would have enough sense to go slow, but I feared she wouldn’t. The chemistry between them was undeniable. I remembered the passion I had shared with Brad. Even with the heartache that followed, it had been worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I could hardly blame Linda for making the same mistake I had.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John and I got lost in conversation till Wade—clearly refortified— stood in a chair and started loudly accompanying Creedence Clear-water Revival in “Bad Moon Rising” in a halfway decent voice. Linda just laughed, then pulled him down when the song ended to a smattering of applause.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Uncle Manny,” she mouthed to me. “I can handle this.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Before I could get mad at Wade for breaking his word about the booze, John fixed on me with sobering intensity. “Georgia?” His breathing suspended. “I’d like to see you, if that’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Sure,” I said casually, delighted that he wanted to go out again.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“I mean, a lot,” he clarified as gingerly as if he were extending some renegade theory of the cosmos.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Exclusively?” Not that I wasn’t willing, but it seemed awfully quick.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“Any way you want,” he conceded, “as long as I’m the one you end up with.”")])]), _c('p', {
    staticClass: "Style24"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Truly a man, declaring his honorable intentions.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "Style24"
  }, [_vm._v("I warmed to him even more. “Exclusive is okay with me,” I murmured, wishing he would kiss me, even though nice girls didn’t kiss on the first date. Not in Buckhead. But we’d had coffee several times, so maybe that counted.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("“But if it doesn’t work out,” I promised, “I’ll tell you straight up.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("John’s smile held all the confidence of a man used to achieving what he wanted. “It’ll work out.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I wasn’t so sure, but it would do for the meantime.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("When we got to Linda’s house, John and I looked the other way while she and Wade made out in the shadows by her front door, then said a lingering good-bye. When Wade got back into the car, he sighed. “Now "), _c('em', [_vm._v("that")]), _vm._v(", ladies and gentlemen, is one hell of a woman.” Then he promptly went to sleep. Or passed out. It was hard to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("When John walked me to my door, I found myself wishing he wasn’t quite as gentlemanly as he was.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("I needn’t have worried. When I turned my face up to say good night, he kissed me long and slow, gentle at first, then wrapping me in his arms and planting one on me that sent a surprising pang of longing where only warmth had been before.")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Then he pulled back abruptly, as if afraid he might have gone too far. “Wow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Style24"
  }, [_vm._v("Reminded of what it felt like to want someone, I looked up at him and murmured. “Maybe this might work out, after all.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa3e8068","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Ch3.vue
// module id = 84
// module chunks = 0